import axios from 'axios';
import { setAlert } from './alert';
import setAuthToken from '../utils/setAuthToken'

import {
    GET_PACKAGE,
    GET_PACKAGES,
    CREATE_PACKAGE,
    UPDATE_PACKAGE,
    DELETE_PACKAGE,
} from './types';

const API_URL = process.env.REACT_APP_SERVER_API_URL;

// Get ProductPackages
export const getProductPackages = (queryString = '') => async dispatch => {
    if( localStorage.token ){
        setAuthToken( localStorage.token )
    }
    
    try {
        const res =  await axios.get(`${API_URL}/product-package/packages${queryString}`);

        if(res.data.success){
            dispatch({
                type : GET_PACKAGES,
                payload: res.data
            });
            dispatch( setAlert('Successfully fetched Product Packages details', 'success') );
        }else{
            dispatch( setAlert(res.data.error, 'danger') );
        }
    } catch (err) {
        dispatch(setAlert('Failed to fetch Products Packages', 'danger'));
    }
}

// Get a Product Package
export const getProductPackage = id => async dispatch => {
    if( localStorage.token ){
        setAuthToken( localStorage.token )
    }
    try {
        const res =  await axios.get(`${API_URL}/product-package/`, {params:{id: id}});
  
        if(res.data.success){  
            dispatch({
                type : GET_PACKAGE,
                payload: res.data.data
            });
            dispatch( setAlert('Successfully fetched Product Package details', 'success') );
        }else{
            dispatch( setAlert(res.data.error, 'danger') );
        }
    } catch (err) {
        dispatch(setAlert('Error: Failed to get Product Package details', 'danger'));
    }
};

// Create product package
export const createProductPackage = (packageData) => async dispatch => {
    if (localStorage.token) {
        setAuthToken(localStorage.token);
    }
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };
    try {
        const res = await axios.post(`${API_URL}/product-package`, packageData, config);
        if (res.data.success) {
            dispatch({
                type: CREATE_PACKAGE,
                payload: res.data.data
            });
            dispatch(setAlert('Package created successfully', 'success'));
            return res.data.data;
        } else {
            dispatch(setAlert(res.data.error, 'danger'));
            return null;
        }
    } catch (err) {
        dispatch(setAlert('Error: Failed to create package', 'danger'));
        return null;
    }
};

// Update product package
export const updateProductPackage = (packageData) => async dispatch => {
    if (localStorage.token) {
        setAuthToken(localStorage.token);
    }
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };
    try {
        const res = await axios.put(`${API_URL}/product-package`, packageData, config);
        if (res.data.success) {
            dispatch({
                type: UPDATE_PACKAGE,
                payload: res.data.data
            });
            dispatch(setAlert('Package updated successfully', 'success'));
            return res.data.data;
        } else {
            dispatch(setAlert(res.data.error, 'danger'));
            return null;
        }
    } catch (err) {
        dispatch(setAlert('Error: Failed to update package', 'danger'));
        return null;
    }
};

// Upload asset to product package
export const uploadPackageAsset = (packageId, assetData) => async dispatch => {
    if (localStorage.token) {
        setAuthToken(localStorage.token);
    }
    const config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    };
    try {
        const res = await axios.put(`${API_URL}/product-package/${packageId}/asset`, assetData, config);
        if (res.data.success) {
            dispatch({
                type: UPDATE_PACKAGE,
                payload: res.data.data
            });
            dispatch(setAlert('Asset uploaded successfully', 'success'));
            return res.data.data;
        } else {
            dispatch(setAlert(res.data.error, 'danger'));
            return null;
        }
    } catch (err) {
        dispatch(setAlert('Error: Failed to upload asset', 'danger'));
        return null;
    }
};

// Delete product package
export const deleteProductPackage = (packageId) => async dispatch => {
    if (localStorage.token) {
        setAuthToken(localStorage.token);
    }
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };
    try {
        const res = await axios.delete(`${API_URL}/product-package/`, {
            ...config,
            data: { id: packageId }
        });
        if (res.data.success) {
            dispatch({
                type: DELETE_PACKAGE,
                payload: packageId
            });
            dispatch(setAlert('Package deleted successfully', 'success'));
            // Refresh the packages list
            dispatch(getProductPackages(''));
        } else {
            dispatch(setAlert(res.data.error, 'danger'));
        }
    } catch (err) {
        dispatch(setAlert('Error: Failed to delete package', 'danger'));
    }
};
